module.exports = __webpack_public_path__ + "img/div-04.da129be0.png";